module.exports = __webpack_public_path__ + "static/media/SD.e32c583d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SD.svg
// module id = 2255
// module chunks = 7